import { Stack } from "@/Components/v2/atoms/Stack";

import {
  GroupedSatCurveLegendCard,
  GroupedSatCurveLegendCardData,
} from "../LegendCard/GroupedSatCurveLegendCard";

interface LegendProps {
  legends: GroupedSatCurveLegendCardData[] | undefined;
  handleHideToggle: (id: string) => void;
  handleLegendItemClick: (id: string) => void;
}

export const GroupedSatCurveLegendCards: React.FC<LegendProps> = ({
  legends,
  handleHideToggle,
  handleLegendItemClick,
}) => {
  return (
    <Stack direction="row" spacing={2} justifyContent="space-between" paddingX={4} paddingY={0}>
      {legends?.map((group) => (
        <GroupedSatCurveLegendCard
          key={group.id}
          group={group}
          handleHideToggle={handleHideToggle}
          handleLegendItemClick={handleLegendItemClick}
        />
      ))}
    </Stack>
  );
};
